export enum KnowledgeSourceEnum {
  /** 手动输入 */
  MANUAL = "MANUAL",
  /** 本地上传 */
  IMPORT = "IMPORT",
  /** 网页链接 */
  Website = "WEBSITE",
  /** 通用搜索 */
  Search = "SEARCH",
}

export enum DatasetStructure {
  /** 普通知识库 */
  common = 1,
  /** 高级知识库 */
  advance = 2,
  /** 智能知识库 */
  smart = 3,
  /** 常见问题 */
  commonProblem = 4,
  /** 纠偏知识 */
  rectificationKnowledge = 5,
  /** 机器人知识 */
  robotKnowledge = 6,
}

export enum KnowledgePeriodicUpdateFrequencyEnum {
  Never = "NEVER",
  Daily = "DAILY",
  Weekly = "WEEKLY",
  Monthly = "MONTHLY",
}

/** 知识来源选项 */
export const KnowledgeSourceOptions = [
  {
    label: "手动输入",
    value: KnowledgeSourceEnum.MANUAL,
  },
  {
    label: "本地上传",
    value: KnowledgeSourceEnum.IMPORT,
  },
  {
    label: "网页链接",
    value: KnowledgeSourceEnum.Website,
  },
  {
    label: "通用搜索",
    value: KnowledgeSourceEnum.Search,
  },
];

export const KnowledgePeriodicUpdateFrequencyOptions = [
  {
    label: "从不更新",
    value: KnowledgePeriodicUpdateFrequencyEnum.Never,
  },
  {
    label: "每日更新",
    value: KnowledgePeriodicUpdateFrequencyEnum.Daily,
  },
  {
    label: "每周更新",
    value: KnowledgePeriodicUpdateFrequencyEnum.Weekly,
  },
  {
    label: "每月更新",
    value: KnowledgePeriodicUpdateFrequencyEnum.Monthly,
  },
];
// 允许的文件类型
export const allowedImageType: string[] = [
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/bmp",
  "image/tiff",
  "image/webp",
];

const allowedAudioType: string[] = [
  "audio/mpeg",
  "audio/wav",
  "audio/aac",
  "audio/flac",
  "audio/ogg",
  "audio/x-ms-wma",
  "audio/mp4",
  "audio/m4a",
  "audio/x-m4a",
];

const allowedVideoType: string[] = [
  "video/mp4",
  "video/x-msvideo",
  "video/x-matroska",
  "video/quicktime",
  "video/x-ms-wmv",
  "video/x-flv",
  "video/webm",
  "video/mpeg",
  "video/avi",
];

const allowedExtraFileType: string[] = [
  ".aac",
  ".flv",
  ".pdf",
  ".odt",
  ".doc",
  ".docx",
  ".odp",
  ".pptx",
  ".ods",
  ".xlsx",
  ".xls",
  ".csv",
  ".txt",
  ".rtf",
  ".md",
  ".xml",
];
const allowedAccept: string = [
  ...allowedImageType,
  ...allowedAudioType,
  ...allowedVideoType,
  ...allowedExtraFileType,
].join(", ");

/** 根据知识库类型获取文件可选类型 */
export const getKnowledgeBaseAccept = () => {
  return allowedAccept;
};

/** 校验知识库上传的文件 */
export const validateKnowledgeUploadFileType = (params: {
  KnowledgeBaseType?: DatasetStructure;
  file: { type: string; name: string };
}) => {
  const { file } = params;
  // 知识库上传文件处理不了+号
  if (file.name.includes("+")) {
    return false;
  }
  //KnowledgeBaseType后端存在一会字符串一会数字，为了健壮KnowledgeBaseType转换为数字再判断
  // if (
  //   +KnowledgeBaseType === DatasetStructure.smart ||
  //   +KnowledgeBaseType === DatasetStructure.common
  // ) {
  const accessList = [
    ...allowedAudioType,
    ...allowedImageType,
    ...allowedVideoType,
  ];
  const typeVerify =
    accessList.includes(file.type) ||
    allowedExtraFileType.includes(
      /(\.[a-z0-9]+)$/.exec(file.name.toLowerCase())![1]
    );
  return typeVerify;
  // } else {
  //   return false;
  // }
};
